module.exports = "/_next/static/images/PayError-788a35f086760ff7dd86b888f47d0c96.svg";